import ReactDOM from 'react-dom/client';

import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import './index.css';

// Yangi deploy qilingandan keyin eski chunk fayllari yo'q bo'ladi.
// Bir martalik qayta yuklash bilan yangi index.html ni olamiz.
const handleChunkLoadError = (error) => {
  const msg = String(error?.message || error || '');
  const isChunkError =
    error?.name === 'ChunkLoadError' ||
    /Loading chunk \d+ failed/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg);

  if (!isChunkError) return;

  const KEY = 'chunk_reload_attempted_at';
  const lastTry = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - lastTry < 30000) return;
  sessionStorage.setItem(KEY, String(Date.now()));
  window.location.reload();
};

window.addEventListener('error', (e) => handleChunkLoadError(e.error || e));
window.addEventListener('unhandledrejection', (e) => handleChunkLoadError(e.reason));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

serviceWorker.unregister();
reportWebVitals();
